import React, { useEffect, useState, useRef, forwardRef } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { open, close } from '../redux/popupSlice';
import { Transition } from 'react-transition-group';
import { isMobile } from 'react-device-detect';

export default function Popup({}) {

    const dispatch = useDispatch();
    const { open, title, message, button, buttonCencle, onCancelPress, onPress, component } = useSelector(state => state.popupReducer);

    const [prevScroll, setPrevScroll] = useState(0)

    const handleClose = () => {
        dispatch(close());
    };

    useEffect(()=>{
        document.addEventListener('mousedown', handleClickOutside);
        return() => {
            document.removeEventListener('mousedown', handleClickOutside);
        }
    });

    /* useEffect(() => {
        if(open) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'unset';
        }
    }, [open]); */

    useEffect(() => {
        if(open) { // 팝업이 열릴 때만 실행
            const scrollY = window.scrollY; // 현재 스크롤 위치 저장
            document.body.style.position = 'fixed'; // 화면을 고정
            document.body.style.top = `-${scrollY}px`; // 현재 위치를 top으로 설정
            document.body.style.left = '0';
            document.body.style.width = '100%';
            
        } else {
            const scrollY = parseInt(document.body.style.top || '0', 10) * -1; // 저장된 top 값을 숫자로 변환
            document.body.style.position = ''; // 원래대로 복구
            document.body.style.top = ''; // top 값 초기화
            window.scrollTo(0, scrollY); // 원래 위치로 복구
        }
    }, [open]);

    const handleClickOutside = (event) => {
        if(event.target.id === 'container_part') handleClose();
    }
    
    return (
        <>
            <div className={open ? "popup show" : "popup"} id="container_part">
                {component ?
                <>
                    {component}
                </>
                :
                <div className="popup_container">
                    <div className="popup_top">
                        <div className="popup_title_section">
                            <p className="popup_title">{title}</p>
                            <button 
                                type="button" 
                                className="exit_btn"
                                onClick={() => {
                                    handleClose();
                                    onCancelPress && onCancelPress();
                                }}>
                                    
                            </button>
                        </div>

                        <p className="popup_msg">{message}</p>
                    </div>

                    <div className="popup_btn">
                        {buttonCencle && 
                            <button 
                                type="button" 
                                className="popbtn cencle_btn"
                                onClick={() => {
                                    handleClose();
                                    onCancelPress && onCancelPress();
                                }}>
                                {buttonCencle}
                            </button>
                        }
                        <button 
                            type="button" 
                            className="popbtn ok_btn"
                            onClick={() => {
                                handleClose();
                                onPress && onPress();
                            }}
                            style={ { width: buttonCencle ? '' : '100%'}}>
                            {button}
                        </button>
                    </div>

                </div>
                }
            </div>
        </>
    );
}